import docsPaneTemplate from './docs-pane.tpl.html';
import './docs-pane.less';
import { markdownComponentModule } from '../markdown/markdown';
import { appConfig } from '../../constants/app-config';

export const getDocsURL = (
  articleId,
  { embedded = false, theme = undefined, section = undefined } = {},
) => {
  if (articleId[0] === '/') {
    articleId = articleId.slice(1);
  }
  const params = [];
  if (embedded) {
    params.push('embedded=true');
  }
  if (theme) {
    params.push(`theme=${theme}`);
  }
  return `${(window.Dev && window.Dev.docsUrl) || appConfig.docsUrl}/${articleId.replace(/_/g, '-')}${params ? '?' + params.join('&') : ''}${section ? '#' + section : ''}`;
};

export const docsPaneComponentModule = angular
  .module('Q.components.docs-pane', [markdownComponentModule])

  .component('docsPane', {
    bindings: {
      articleId: '=',
      homeArticle: '=?',
      articleList: '<',
      articleListTitle: '@',
      articleListContent: '<',
      theme: '@',
      hideToolbar: '<',
    },
    controller: 'DocsPaneCtrl',
    template: docsPaneTemplate,
  })

  .controller(
    'DocsPaneCtrl',
    function DocsPaneCtrl(
      $scope,
      $element,
      $rootScope,
      $sce,
      $timeout,
      $window,
    ) {
      const ctrl = this;

      let lastTheme;

      const loadArticle = (ctrl.loadArticle = (articleId = ctrl.articleId) => {
        ctrl.articleId = articleId;
        ctrl.src = '';
        if (articleId) {
          lastTheme = $rootScope.$ideDarkClass;
          ctrl.src = $sce.trustAsResourceUrl(
            getDocsURL(articleId, {
              embedded: true,
              theme: ctrl.theme || $rootScope.$ideDarkClass || 'light',
            }),
          );
        }
      });

      ctrl.$onInit = () => {
        if (!ctrl.homeArticle) {
          ctrl.homeArticle = ctrl.articleId;
        }
        loadArticle();
      };

      $scope.$watch('$ctrl.articleId', () => {
        loadArticle();
      });

      $scope.$watch(
        () => $rootScope.$ideDarkClass,
        () => {
          if ($rootScope.$ideDarkClass !== lastTheme) {
            // TODO: set the article theme without losing the current URL
            loadArticle();
          }
        },
      );

      ctrl.goHome = () => {
        ctrl.src = '';
        if (ctrl.homeArticle) {
          ctrl.articleId = ctrl.homeArticle;
        } else if (ctrl.articleList) {
          ctrl.articleId = null;
        }
        $timeout(loadArticle);
      };

      // ctrl.go = (dir) => {
      //	// TODO: handle history control via postmessage?
      // };

      ctrl.newWindow = () => {
        if (ctrl.src) {
          // TODO: handle when we've navigated away from the original source
          //   This requires using postMessage, or figuring out how to make the
          //   domains effectively the same
          $window.open(ctrl.src.toString().replace(/embedded=true&?/, ''));
        }
      };
    },
  );
